// 密码ase加密前缀
const PASS_WORD_SECRETKEY = 'QUAN_XIN';
// 跳转后台地址
const BACK_STAGE_URL = 'http://192.168.0.186:9999';

export { PASS_WORD_SECRETKEY, BACK_STAGE_URL };
